const translation = {
  Product: "ผลิตภัณฑ์",
  "Header.productNav": "ผลิตภัณฑ์ LUKKEY",
  Feature: "คุณสมบัติ",
  "About Us": "เกี่ยวกับเรา",
  FAQ: "คำถามที่พบบ่อย",
  "Privacy Policy": "นโยบายความเป็นส่วนตัว",
  "Help Center": "ศูนย์ช่วยเหลือ",
  "Header.infoMenu": "เพิ่มเติม",
  "Header.appNow": "ดาวน์โหลดแอป",
  "Header.appModal.title": "ใช้งานแอป LUKKEY ตอนนี้",
  "Header.appModal.subtitle": "เลือกแพลตฟอร์มของคุณเพื่อรับแอปมือถือทางการของ LUKKEY",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "ติดตั้งแอปทางการบน iPhone",
  "Header.appModal.iosButton": "เปิด",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "รับแอป Android ทางการบน Google Play",
  "Header.appModal.googlePlayButton": "เปิด",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "ดาวน์โหลด APK ทางการเวอร์ชันล่าสุดโดยตรง",
  "Header.appModal.androidButton": "ดาวน์โหลด",
  "Header.appModal.note": "ดาวน์โหลดผ่านมือถืออย่างเป็นทางการเท่านั้น ใช้ลิงก์ด้านบนเพื่อรับเวอร์ชันล่าสุด",
  "Academy": "สถาบัน",
  "Legal": "ข้อมูลทางกฎหมาย",
  "AboutUs.title": "เกี่ยวกับ LUKKEY",
  "AboutUs.lede": "LUKKEY เป็นแบรนด์ฮาร์ดแวร์วอลเล็ตจากสวิตเซอร์แลนด์ที่ทุ่มเทสร้างมาตรฐานความปลอดภัยสูงสุดสำหรับการถือครองสินทรัพย์ดิจิทัล",
  "AboutUs.vision.closing": "คีย์ของคุณ สินทรัพย์ของคุณ อนาคตของคุณ",
  "AboutUs.quote": "LUKKEY สร้างชั้นความปลอดภัยระหว่างผู้คนกับสินทรัพย์ดิจิทัล",
  "AboutUs.block1": "LUKKEY มีฐานอยู่ในสวิตเซอร์แลนด์ และมุ่งเน้นฮาร์ดแวร์วอลเล็ตที่ออกแบบมาสำหรับการดูแลสินทรัพย์ด้วยตนเองอย่างปลอดภัย",
  "AboutUs.block2": "ผลิตภัณฑ์ของบริษัทผสานชิปความปลอดภัย การป้องกันการงัดแงะ และสถาปัตยกรรมออฟไลน์เต็มรูปแบบ เป้าหมายคือเก็บคีย์ส่วนตัวไว้ในสภาพแวดล้อมที่แยกออกจากกัน",
  "AboutUs.block3": "ระบบถูกออกแบบโดยไม่พึ่งพา Wi‑Fi, USB หรือเครือข่ายโดยตรง การเข้าถึงด้วยลายนิ้วมือ เครื่องมือสำรองข้อมูล NFC และการรองรับสินทรัพย์ที่กว้าง ทำให้ใช้งานได้จริงในชีวิตประจำวัน",
  "AboutUs.block5": "LUKKEY ใช้แนวทางแบบเปิดและตรวจสอบได้กับเฟิร์มแวร์และซอฟต์แวร์หลัก ข้ออ้างด้านความปลอดภัยควรสามารถตรวจสอบและยืนยันได้",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "คำขอการสนับสนุน",
  "WarrantySupport.intro": "โปรดกรอกข้อมูลด้านล่างเพื่อส่งคำขอการสนับสนุนของคุณ",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "สรุปปัญหา",
  "WarrantySupport.form.issueTitle.placeholder": "ใส่สรุปสั้น ๆ",
  "WarrantySupport.form.warrantyType.label": "ประเภทคำขอ",
  "WarrantySupport.form.warrantyType.placeholder": "เลือกประเภทคำขอ",
  "WarrantySupport.form.warrantyType.product": "ปัญหาอุปกรณ์",
  "WarrantySupport.form.warrantyType.service": "ปัญหาแอป/บัญชี",
  "WarrantySupport.form.warrantyType.replacement": "อื่นๆ",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "อธิบายปัญหาหรือคำขอโดยละเอียด",
  "WarrantySupport.form.submit": "ส่งคำขอการสนับสนุน",
  "WarrantySupport.alert.success": "ส่งคำขอการสนับสนุนเรียบร้อยแล้ว!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "ศูนย์ช่วยเหลือ",
  "HelpCenter.intro":
    "ยินดีต้อนรับสู่ศูนย์ช่วยเหลือ LUKKEY! หากคุณเป็นมือใหม่ในคริปโตหรือจำเป็นต้องขอความช่วยเหลือเกี่ยวกับกระเป๋าเงินแบบเย็น คุณมาถูกที่แล้ว โซลูชันกระเป๋าเงินแบบเย็นของเราเป็นวิธีที่ปลอดภัยที่สุดในการจัดเก็บและจัดการสินทรัพย์ดิจิทัลของคุณ ด้านล่างนี้คือคำตอบสำหรับคำถามที่พบบ่อยและเคล็ดลับการแก้ไขปัญหา",
  "HelpCenter.section4.title": "ต้องการความช่วยเหลือเพิ่มเติมไหม?",
  "HelpCenter.section4.intro":
    "ประหยัดเวลาด้วยการเริ่มคำขอการสนับสนุนออนไลน์ แล้วเราจะเชื่อมต่อคุณกับผู้เชี่ยวชาญ เพื่อความปลอดภัย ทีมซัพพอร์ตอย่างเป็นทางการจะไม่ขอวลีการกู้คืนหรือคีย์ส่วนตัวของคุณ:",
  "HelpCenter.contact.hint": "ใช้ปุ่มเพื่อส่งคำขอการสนับสนุน แล้วเราจะติดต่อคุณทางอีเมล",
  "HelpCenter.cta.warranty": "ส่งคำขอการสนับสนุน",
  brandName: "LUKKEY",
  tagline: "จัดการคริปโตของคุณในแบบที่ไม่เคยมีมาก่อน",
  description:
    "เริ่มต้นการเดินทางสู่เสรีภาพทางการเงินของคุณด้วยแอพของเรา ปกป้องสินทรัพย์ของคุณด้วยเทคโนโลยีกระเป๋าเย็นขั้นสูงและจัดการการเงินของคุณอย่างชาญฉลาดและมีประสิทธิภาพ ความเป็นอยู่ทางการเงินของคุณคือสิ่งที่เราคำนึงถึงมากที่สุด",
  "home.seoTitle": "LUKKEY | ฮาร์ดแวร์วอลเล็ตจากสวิตเซอร์แลนด์สำหรับ self-custody ที่ปลอดภัย",
  "home.seoDescription": "LUKKEY เป็นแบรนด์ฮาร์ดแวร์วอลเล็ตจากสวิตเซอร์แลนด์ที่เน้นความปลอดภัยของ cold wallet การปกป้อง private key แบบออฟไลน์ การเข้าถึงด้วยลายนิ้วมือ และการสำรองข้อมูลด้วย NFC เพื่อ self-custody ที่ปลอดภัย",
  learnMore: "เรียนรู้เพิ่มเติม",
  "Lock Your Crypto, Securely": "ล็อคคริปโตของคุณอย่างปลอดภัย",
  Testimonials: "คำรับรอง",
  Testimonial1:
    "ฉันใช้กระเป๋าเย็นนี้มาหลายเดือนแล้ว และประทับใจกับความน่าเชื่อถือและคุณสมบัติด้านความปลอดภัยของมัน แนะนำเป็นอย่างยิ่ง!",
  Testimonial2:
    "กระเป๋าเย็นนี้เกินความคาดหมายของฉัน! อินเทอร์เฟซที่ใช้งานง่ายและความปลอดภัยระดับสูงทำให้มันเป็นเครื่องมือที่ขาดไม่ได้สำหรับทุกคนที่จริงจังกับการลงทุนในคริปโต",
  Testimonial3:
    "ฉันเคยลองใช้กระเป๋าเย็นหลายใบ แต่ใบนี้โดดเด่น การออกแบบที่ดูดีและฟีเจอร์ที่ทันสมัยทำให้การจัดการสินทรัพย์คริปโตของฉันเป็นเรื่องง่าย",
  "John Doe": "จอห์น โด",
  "Cryptocurrency Enthusiast": "ผู้หลงใหลในคริปโต",
  "Jane Smith": "เจน สมิธ",
  "Crypto Security Advocate": "ผู้สนับสนุนความปลอดภัยในคริปโต",
  "Alex Johnson": "อเล็กซ์ จอห์นสัน",
  "Investment Analyst": "นักวิเคราะห์การลงทุน",
  "Touchscreen Interface": "อินเตอร์เฟซหน้าจอสัมผัส",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "สัมผัสประสบการณ์การจัดการคริปโตที่ไร้รอยต่อด้วยอินเตอร์เฟซหน้าจอสัมผัสที่ใช้งานง่าย ออกแบบมาเพื่อการนำทางอย่างรวดเร็วและง่ายดายผ่านสินทรัพย์ดิจิทัลของคุณ ทำให้สามารถทำธุรกรรมได้รวดเร็วและจัดการได้อย่างปลอดภัยด้วยปลายนิ้วของคุณ",
  "Bluetooth Connectivity": "การเชื่อมต่อ Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "การซิงค์แบบไร้สายกับอุปกรณ์ของคุณเพื่อการอัปเดตแบบเรียลไทม์",
  "Airtag Tracking": "การติดตาม Airtag",
  "Track your wallet easily with built-in Airtag.":
    "ติดตามกระเป๋าของคุณได้ง่ายๆ ด้วย Airtag ที่ติดตั้งมาแล้ว",
  "Secure Chip Technology": "เทคโนโลยีชิปที่ปลอดภัย",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "มาพร้อมกับชิปความปลอดภัยขั้นสูงที่รับประกันการปกป้องที่แข็งแกร่งสำหรับสินทรัพย์ดิจิทัลที่มีค่า จากการเข้าถึงโดยไม่ได้รับอนุญาตและภัยคุกคามทางไซเบอร์",
  "Cross-Platform Support": "รองรับหลายแพลตฟอร์ม",
  "Works with various platforms for easy accessibility.":
    "ทำงานร่วมกับแพลตฟอร์มต่างๆ เพื่อให้เข้าถึงได้ง่าย",
  AboutUsDescription1:
    "ที่ LUKKEY เราทุ่มเทในการให้บริการโซลูชันคุณภาพสูงสำหรับการจัดการสินทรัพย์คริปโตของคุณอย่างปลอดภัย",
  AboutUsDescription2:
    "สำนักงานใหญ่ของเราตั้งอยู่ที่เมืองซุก ประเทศสวิตเซอร์แลนด์ ด้วยทีมงานมืออาชีพที่มีประสบการณ์ เรามุ่งมั่นที่จะสร้างนวัตกรรมและปรับตัวให้เข้ากับตลาดสกุลเงินดิจิทัลที่มีการเปลี่ยนแปลงอย่างต่อเนื่อง",
  BlockchainNetworksSupported: "เครือข่ายบล็อกเชนที่รองรับ",
  CryptocurrenciesSupported: "รองรับมากกว่า 6,000 สกุลเงินดิจิทัล",
  Years: "ปี",
  ExpertiseInSecurity: "ประสบการณ์ด้านความปลอดภัย",
  FrequentlyAskedQuestions: "คำถามที่พบบ่อย",
  WhatIsColdWallet: "Cold Wallet คืออะไร?",
  ColdWalletDescription:
    "Cold Wallet คือกระเป๋าเงินคริปโตที่เก็บสินทรัพย์ดิจิทัลของคุณแบบออฟไลน์ ทำให้มีความเสี่ยงต่อการถูกแฮ็คและภัยคุกคามออนไลน์อื่นๆ น้อยลง ต่างจาก Hot Wallet ที่เชื่อมต่อกับอินเทอร์เน็ตและสะดวกในการทำธุรกรรมบ่อยๆ Cold Wallet เหมาะสำหรับการเก็บรักษาระยะยาวเพราะให้ความปลอดภัยที่ดีกว่า",
  HowToSetUpColdWallet: "การตั้งค่า Cold Wallet ของคุณทำอย่างไร?",
  ColdWalletSetupDescription:
    "การตั้งค่า Cold Wallet ของคุณโดยปกติจะเกี่ยวข้องกับการเริ่มต้นใช้งานอุปกรณ์บนเครื่องที่ปลอดภัยและไม่เชื่อมต่อกับอินเทอร์เน็ต คุณจะต้องสร้างและเก็บรักษาคำฟื้นฟู (recovery phrase) ไว้อย่างปลอดภัย ซึ่งเป็นสิ่งสำคัญในการเข้าถึงสินทรัพย์ของคุณในกรณีที่อุปกรณ์สูญหายหรือเสียหาย คำแนะนำโดยละเอียดจะมีให้เมื่อคุณทำการซื้อเพื่อให้กระบวนการตั้งค่าราบรื่น",
  CryptocurrenciesCompatibleWithColdWallet:
    "สกุลเงินดิจิทัลใดที่รองรับกับ Cold Wallet ของคุณ?",
  CryptocurrenciesCompatibilityDescription:
    "Cold Wallet ของเรารองรับสกุลเงินดิจิทัลหลายประเภท รวมถึง Bitcoin, Ethereum, Litecoin และเหรียญอื่นๆ สำหรับรายการสกุลเงินทั้งหมดที่รองรับ กรุณาเยี่ยมชมเว็บไซต์ของเราหรืออ้างอิงจากเอกสารผลิตภัณฑ์",
  HowToSecureColdWallet: "ฉันจะทำให้ Cold Wallet ของฉันปลอดภัยได้อย่างไร?",
  ColdWalletSecurityDescription:
    "เพื่อให้ Cold Wallet ของคุณปลอดภัย ให้เก็บคำฟื้นฟูในที่ปลอดภัยและส่วนตัว อย่าแบ่งปันกับใคร และพิจารณาใช้มาตรการรักษาความปลอดภัยเพิ่มเติม เช่น การล็อกด้วยลายนิ้วมือหรือการใช้กล่องปลอดภัย การอัปเดตเฟิร์มแวร์ของกระเป๋าเงินจากเว็บไซต์ทางการอย่างสม่ำเสมอจะช่วยป้องกันช่องโหว่ได้เช่นกัน",
  ColdWalletNotWorking:
    "หาก Cold Wallet ของฉันไม่ทำงานหรือพบข้อผิดพลาดควรทำอย่างไร?",
  ColdWalletErrorDescription:
    "หากคุณประสบปัญหากับ Cold Wallet ของคุณ กรุณาดูส่วนแก้ไขปัญหาในคู่มือผู้ใช้ สำหรับปัญหาที่เฉพาะเจาะจงมากขึ้น ติดต่อทีมสนับสนุนของเราผ่านเว็บไซต์ของเรา อย่าลืมเตรียมข้อมูลอุปกรณ์ของคุณเพื่อให้กระบวนการสนับสนุนรวดเร็วยิ่งขึ้น",
  Community: "ชุมชน",
  "Subscribe.title": "รับอัปเดตผลิตภัณฑ์",
  "Subscribe.subtitle":
    "เราติดตามเทรนด์คริปโตแทนคุณ รับอัปเดตผลิตภัณฑ์ ข้อมูลเชิงลึกของตลาด และสิทธิพิเศษ — ส่งตรงถึงกล่องจดหมายของคุณ",
  "Subscribe.placeholder": "กรอกอีเมลของคุณ",
  "Subscribe.button": "สมัครรับอัปเดตผลิตภัณฑ์",
  "Subscribe.input.aria": "ช่องกรอกที่อยู่อีเมล",
  "Subscribe.success": "ขอบคุณที่สมัครรับข่าวสาร! โปรดตรวจสอบอีเมลยืนยันของคุณ",
  "Subscribe.error": "สมัครไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง",
  "Subscribe.invalid": "โปรดกรอกที่อยู่อีเมลที่ถูกต้อง",
  "Subscribe.privacy":
    "เราจะใช้ที่อยู่อีเมลของคุณเพื่อส่งจดหมายข่าวและอัปเดตเท่านั้น คุณสามารถยกเลิกการรับได้ทุกเมื่อผ่านลิงก์ในอีเมล",
  "Subscribe.learnMore":
    "เรียนรู้เพิ่มเติมเกี่ยวกับการจัดการข้อมูลและสิทธิ์ของคุณ",
  "Subscribe.popupCompact.title": "ติดตามอัปเดต",
  "Subscribe.popupCompact.subtitle":
    "อัปเดตสินค้าและข้อมูลด้านความปลอดภัย ไม่มีสแปม",
  "Subscribe.popupCompact.button": "สมัคร",
  "Subscribe.popupCompact.privacy":
    "ใช้อีเมลเท่านั้น ยกเลิกได้ทุกเมื่อ",
  "SubscribeConfirmed.alt.success": "ยืนยันการสมัครสำเร็จ",
  "SubscribeConfirmed.alt.failed": "การสมัครไม่สำเร็จ",
  "SubscribeConfirmed.title.success": "ยืนยันการสมัครสำเร็จ",
  "SubscribeConfirmed.title.failed": "การสมัครไม่สำเร็จ",
  "SubscribeConfirmed.message.success":
    "ขอบคุณที่ยืนยันอีเมลของคุณ การสมัครของคุณเปิดใช้งานแล้ว อีเมลต้อนรับได้ถูกส่งไปยังกล่องจดหมายของคุณ",
  "SubscribeConfirmed.message.failed":
    "ลิงก์ยืนยันไม่ถูกต้องหรือหมดอายุ โปรดกลับไปที่หน้าแรกและลองสมัครใหม่อีกครั้ง",
  "SubscribeConfirmed.cta.backHome": "กลับไปหน้าแรก",
  "SubscribeConfirmed.note.unsubscribe":
    "คุณสามารถยกเลิกการรับได้ทุกเมื่อผ่านลิงก์ในอีเมลของเรา",
  // ===== MarketView i18n =====
  "MarketView.title": "แดชบอร์ดตลาด",
  "MarketView.loading": "กำลังโหลด...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "ไม่สามารถแสดงแท็บนี้ได้",
  "MarketView.unknownError": "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",

  // ===== Common i18n =====
  "Common.refresh": "รีเฟรช",
  "Common.toggleSeriesVisibility": "สลับการแสดงผลชุดข้อมูลนี้",
  "Common.error": "ข้อผิดพลาด",
  "Common.dataUpdateTime": "เวลาที่อัปเดตข้อมูล",
  "Common.loading": "กำลังโหลด...",
  "Common.noDataSource": "ไม่มีข้อมูล (ไม่ได้ระบุแหล่งข้อมูล)",

  // ===== Common ranges =====
  "Common.to": "ถึง",
  "Common.clear": "ล้าง",
  "Common.range.thisMonth": "เดือนนี้",
  "Common.range.lastMonth": "เดือนที่แล้ว",
  "Common.range.last2": "2 เดือนล่าสุด",
  "Common.range.last3": "3 เดือนล่าสุด",
  "Common.range.last6": "6 เดือนล่าสุด",
  "Common.range.thisYear": "ปีนี้",
  "Common.range.all": "ทั้งหมด",
  "Common.range.custom": "กำหนดเอง",
  "Common.showFilters": "แสดงตัวกรอง",
  "Common.hideFilters": "ซ่อนตัวกรอง",
  "Common.search": "ค้นหา",
  "Common.priority": "ความสำคัญ",
  "Common.owner": "ผู้รับผิดชอบ",
  "Common.collaborator": "ผู้ร่วมงาน",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "ดาวน์โหลด backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "ดาวน์โหลด youtube_stats.json",
  "YouTubeTab.loading": "กำลังโหลดตัวชี้วัด YouTube...",
  "YouTubeTab.errorHint":
    "หากยังไม่ได้ตั้งค่า API Key ให้กำหนด YOUTUBE_API_KEY หรือ GOOGLE_API_KEY ใน backend/.env และรีสตาร์ทแบ็กเอนด์",
  "YouTubeTab.header.totalViews": "จำนวนการรับชมรวม (หลายช่อง, หน่วย: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "จำนวนผู้ติดตามรวม (หลายช่อง, หน่วย: 10k)",
  "YouTubeTab.dist.views": "การกระจายการรับชม (10k)",
  "YouTubeTab.dist.subscribers": "การกระจายผู้ติดตาม (10k)",
  "YouTubeTab.card.location": "ภูมิภาค:",
  "YouTubeTab.card.registeredAt": "ลงทะเบียนเมื่อ:",
  "YouTubeTab.card.currentSubscribers": "ผู้ติดตามปัจจุบัน",
  "YouTubeTab.card.currentVideos": "จำนวนวิดีโอปัจจุบัน",
  "YouTubeTab.card.currentTotalViews": "จำนวนการรับชมรวมปัจจุบัน",
  "YouTubeTab.card.currentTotalComments": "จำนวนความคิดเห็นรวมปัจจุบัน",
  "YouTubeTab.chart.totalSubscribers": "ผู้ติดตามรวม",
  "YouTubeTab.chart.totalViews": "การรับชมรวม",
  "YouTubeTab.chart.totalComments": "ความคิดเห็นรวม",
  "YouTubeTab.chart.totalVideos": "วิดีโอรวม",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "ดาวน์โหลด backend data/x_stats.json",
  "XTab.downloadJson": "ดาวน์โหลด x_stats.json",
  "XTab.loading": "กำลังโหลดตัวชี้วัด X...",
  "XTab.errorHint":
    "หากยังไม่ได้ตั้งค่า Token ให้กำหนด X_BEARER_TOKEN หรือ TWITTER_BEARER_TOKEN ใน backend/.env และรีสตาร์ทแบ็กเอนด์",
  "XTab.header.totalFollowers": "จำนวนผู้ติดตามรวม (หลายช่อง, หน่วย: 10k)",
  "XTab.header.totalEngagement":
    "จำนวนปฏิสัมพันธ์รวม (5 โพสต์ล่าสุด: ไลก์ + รีทวีต + ตอบกลับ + อ้างอิง, หน่วย: 10k)",
  "XTab.dist.followers": "การกระจายผู้ติดตาม (10k)",
  "XTab.dist.engagement":
    "การกระจายปฏิสัมพันธ์ (5 โพสต์ล่าสุด: ไลก์ + รีทวีต + ตอบกลับ + อ้างอิง, หน่วย: 10k)",
  "XTab.card.currentFollowers": "ผู้ติดตามปัจจุบัน",
  "XTab.card.currentFollowing": "กำลังติดตามปัจจุบัน",
  "XTab.card.currentTweets": "จำนวนทวีตปัจจุบัน",
  "XTab.card.recentLikes": "ไลก์ล่าสุด (5 โพสต์ล่าสุด)",
  "XTab.card.recentRetweets": "รีทวีตล่าสุด (5 โพสต์ล่าสุด)",
  "XTab.card.recentReplies": "การตอบกลับล่าสุด (5 โพสต์ล่าสุด)",
  "XTab.card.recentQuotes": "การเข้าชมล่าสุด (ระดับคอนเทนต์, 5 โพสต์ล่าสุด)",
  "XTab.card.listed": "จำนวนการถูกจัดลิสต์ (ระดับช่อง)",
  "XTab.smallChart.followers": "ผู้ติดตาม",
  "XTab.smallChart.tweets": "ทวีต",
  "XTab.smallChart.likes": "ไลก์ล่าสุด",
  "XTab.smallChart.retweets": "รีทวีตล่าสุด",
  "XTab.smallChart.replies": "การตอบกลับล่าสุด",
  "XTab.smallChart.quotes": "การเข้าชมล่าสุด (ระดับคอนเทนต์)",
  "XTab.smallChart.following": "กำลังติดตาม",
  "XTab.smallChart.listed": "ถูกจัดลิสต์",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "กรองตามเดือนที่สร้าง:",
  "Analytics.metric.completionRate": "อัตราการแล้วเสร็จ",
  "Analytics.metric.teamVelocity": "ความเร็วทีม",
  "Analytics.metric.blockerRatio": "สัดส่วนสิ่งกีดขวาง",
  "Analytics.metric.workloadBalance": "สมดุลงาน",
  "Analytics.charts.statusDistribution": "การกระจายสถานะ",
  "Analytics.charts.statusByMonthPercent": "สถานะรายเดือน (เปอร์เซ็นต์)",
  "Analytics.charts.priorityDistribution": "การกระจายความสำคัญ",
  "Analytics.charts.priorityByMonthPercent": "ความสำคัญรายเดือน (เปอร์เซ็นต์)",
  "Analytics.charts.functionTypeDistribution": "การกระจายประเภทหน้าที่",
  "Analytics.charts.functionTypeByMonthPercent":
    "ประเภทหน้าที่รายเดือน (เปอร์เซ็นต์)",
  "Analytics.blocker.ownerPie":
    "ปัญหาที่ถูกบล็อก · การกระจายผู้รับผิดชอบ (โดนัท)",
  "Analytics.blocker.ownerByMonth":
    "ปัญหาที่ถูกบล็อก · ผู้รับผิดชอบรายเดือน (เปอร์เซ็นต์)",
  "Analytics.bug.ownerPie": "ปัญหา Bug · การกระจายผู้รับผิดชอบ (โดนัท)",
  "Analytics.bug.ownerByMonth":
    "ปัญหา Bug · ผู้รับผิดชอบรายเดือน (เปอร์เซ็นต์)",
  "Analytics.ownerWorkloadDistribution": "การกระจายภาระงานของทีม",
  "Analytics.mode.priority": "โหมดความสำคัญ",
  "Analytics.mode.status": "โหมดสถานะ",
  "Analytics.mode.type": "โหมดประเภท",
  "Analytics.blocker.attentionNeeded": "ปัญหาที่ต้องให้ความสนใจทันที",
  "Analytics.common.status": "สถานะ",
  "Analytics.common.owner": "ผู้รับผิดชอบ",
  "Analytics.insights.sectionTitle": "ข้อมูลเชิงลึกและคำแนะนำโครงการ",
  "Analytics.insights.efficiency.title": "ข้อเสนอแนะเพื่อเพิ่มประสิทธิภาพ",
  "Analytics.insights.efficiency.completionRate":
    "• อัตราการแล้วเสร็จปัจจุบันคือ {{rate}}% โปรดเฝ้าระวังสิ่งกีดขวาง",
  "Analytics.insights.efficiency.avgVelocity":
    "• ความเร็วเฉลี่ยของทีมคือ {{velocity}} งาน/คน",
  "Analytics.insights.efficiency.workloadBalance":
    "• สมดุลงานอยู่ที่ {{balance}}%",
  "Analytics.insights.risk.title": "การเตือนความเสี่ยง",
  "Analytics.insights.risk.blockerRatio": "• สัดส่วนสิ่งกีดขวาง {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• สัดส่วนปัญหาระดับ P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion": "• แก้ไขปัญหาที่มีความสำคัญสูงก่อน",

  // ===== Kanban i18n =====
  "Kanban.title": "มุมมองคัมบัง",
  "Kanban.totalIssues": "ทั้งหมด {{count}} ปัญหา",
  "Kanban.searchPlaceholder":
    "ค้นหาชื่อเรื่อง หมายเลขปัญหา ผู้รับผิดชอบ หรือผู้ร่วมงาน...",
  "Kanban.status.backlog": "รอดำเนินการ",
  "Kanban.status.inProgress": "กำลังดำเนินการ",
  "Kanban.status.blocked": "ถูกบล็อก / รอยืนยัน",
  "Kanban.status.reviewTest": "ทบทวน / ทดสอบ",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "รายการปัญหา",
  "List.totalIssues": "ทั้งหมด {{count}} ปัญหา",
  "List.viewDetails": "ดูรายละเอียด",
  "List.openInNewWindow": "เปิดในหน้าต่างใหม่",
  "List.empty.title": "ไม่มีปัญหา",
  "List.empty.subtitle": "สร้างปัญหาแรกเพื่อเริ่มเวิร์กโฟลว์ของคุณ",

  // ===== Assets Register i18n =====
  "Assets.title": "ทะเบียนทรัพย์สิน",
  "Assets.totalSets": "จำนวนชุดทั้งหมด",
  "Assets.table.employee": "พนักงาน",
  "Assets.table.setCount": "ชุด",
  "Assets.table.model": "รุ่น",
  "Assets.total": "รวม",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "การติดตามปัญหาโครงการ",
  "LukkeyIssues.goToDemo": "ไปที่หน้าสาธิต",
  "LukkeyIssues.githubProject": "โครงการ GitHub ↗",
  "LukkeyIssues.githubManageIssues": "จัดการ Issues โดยตรงบน GitHub ↗",
  "LukkeyIssues.financeModel": "โมเดลการเงิน",
  "LukkeyIssues.productCoreIssues": "ปัญหาหลักของผลิตภัณฑ์",
  "LukkeyIssues.stats.totalIssues": "📊 จำนวนปัญหาทั้งหมด",
  "LukkeyIssues.stats.completed": "✅ เสร็จสมบูรณ์",
  "LukkeyIssues.stats.inProgress": "🔄 กำลังดำเนินการ",
  "LukkeyIssues.stats.pending": "⏳ รอดำเนินการ",
  "LukkeyIssues.stats.blocked": "🚫 ถูกบล็อก",
  "LukkeyIssues.stats.docs": "📚 เอกสาร Docs",
  "LukkeyIssues.tabs.kanban": "มุมมองคัมบัง",
  "LukkeyIssues.tabs.analytics": "การวิเคราะห์",
  "LukkeyIssues.tabs.market": "แดชบอร์ดตลาด",
  "LukkeyIssues.tabs.assets": "ทะเบียนทรัพย์สิน",
  "LukkeyIssues.shareToChatGPT": "เปิด LUKKEY.json ด้วย ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "นโยบายความเป็นส่วนตัวของ LUKKEY",
  "PrivacyPolicy.intro.p1":
    "ที่ LUKKEY เราเชื่อว่าความเป็นส่วนตัวที่ปลอดภัยที่สุดคือความเป็นส่วนตัวที่อยู่ในมือของผู้ใช้เสมอ",
  "PrivacyPolicy.intro.p2":
    "ดังนั้น ไม่ว่าคุณจะใช้ฮาร์ดแวร์กระเป๋าเงินเย็น LUKKEY หรือแอปพลิเคชันบนมือถือ LUKKEY (แอป) เราปฏิบัติตามหลักการที่ไม่สั่นคลอนเพียงข้อเดียวอย่างเคร่งครัด:",
  "PrivacyPolicy.intro.p3_strong":
    "เว้นแต่ผู้ใช้จะอนุญาตอย่างชัดแจ้ง เราจะไม่เก็บรวบรวม จัดเก็บ หรืออัปโหลดข้อมูลผู้ใช้ใดๆ",
  "PrivacyPolicy.intro.p3_tail":
    "ข้อมูลการใช้งานทั้งหมดจะถูกจัดเก็บไว้เฉพาะภายในอุปกรณ์ของผู้ใช้เท่านั้น และจะไม่ถูกส่งไปยัง LUKKEY หรือเซิร์ฟเวอร์ใดๆ",
  "PrivacyPolicy.intro.p4":
    "นโยบายความเป็นส่วนตัวฉบับนี้อธิบายว่าเรายึดมั่นหลักการนี้อย่างไร",

  "PrivacyPolicy.s1.title": "1. ขอบเขตการบังคับใช้",
  "PrivacyPolicy.s1.appliesTo": "นโยบายความเป็นส่วนตัวนี้ใช้กับ:",
  "PrivacyPolicy.s1.item.hardware": "ฮาร์ดแวร์กระเป๋าเงินเย็น LUKKEY",
  "PrivacyPolicy.s1.item.app": "แอปพลิเคชันบนมือถือ LUKKEY (แอป)",
  "PrivacyPolicy.s1.principle":
    "ทั้งสองปฏิบัติตามหลักการความเป็นส่วนตัวแบบ “ไม่เก็บข้อมูล ไม่อัปโหลด จัดเก็บเฉพาะในเครื่อง”",

  "PrivacyPolicy.s2.title": "2. ข้อมูลที่เราไม่เก็บรวบรวม",
  "PrivacyPolicy.s2.desc":
    "เพื่อคุ้มครองความเป็นส่วนตัวของคุณ เราขอให้คำมั่นอย่างชัดเจนว่าจะไม่เก็บรวบรวม อัปโหลด หรือจัดเก็บข้อมูลผู้ใช้ใดๆ รวมถึงแต่ไม่จำกัดเพียง:",
  "PrivacyPolicy.s2.li.identity":
    "ข้อมูลระบุตัวตน: ชื่อ หมายเลขโทรศัพท์ ที่อยู่อีเมล ที่อยู่ไปรษณีย์",
  "PrivacyPolicy.s2.li.walletSensitive":
    "ข้อมูลกระเป๋าเงินที่อ่อนไหว: กุญแจส่วนตัว (Private Keys) วลีช่วยจำ (Mnemonic) ไฟล์ keystore รหัสผ่านกระเป๋าเงิน",
  "PrivacyPolicy.s2.li.blockchain":
    "ข้อมูลบล็อกเชน: ที่อยู่กระเป๋าเงิน ประวัติธุรกรรม ข้อมูลสินทรัพย์",
  "PrivacyPolicy.s2.li.behavior":
    "พฤติกรรมการใช้งาน: บันทึกการทำงานของแอป (App logs) บันทึกการคลิก การวิเคราะห์พฤติกรรม",
  "PrivacyPolicy.s2.li.technical":
    "ข้อมูลทางเทคนิค: รหัสระบุอุปกรณ์ พิกัดตำแหน่งทางภูมิศาสตร์ ที่อยู่ IP",
  "PrivacyPolicy.s2.inShort.title": "โดยสรุป:",
  "PrivacyPolicy.s2.inShort.desc":
    "ทุกสิ่งที่คุณเห็นในอุปกรณ์ฮาร์ดแวร์และในแอปมีอยู่เฉพาะบนอุปกรณ์ของคุณเท่านั้น LUKKEY ไม่สามารถเข้าถึงได้",

  "PrivacyPolicy.s3.title":
    "3. การออกแบบด้านความเป็นส่วนตัวและความปลอดภัยของฮาร์ดแวร์กระเป๋าเงินเย็น",
  "PrivacyPolicy.s3.desc":
    "กระเป๋าเงินเย็นของ LUKKEY มอบสภาพแวดล้อมที่ปลอดภัยแบบออฟไลน์อย่างเต็มรูปแบบ คุณลักษณะสำคัญได้แก่:",
  "PrivacyPolicy.s3.h1.title": "1. ฮาร์ดแวร์ความปลอดภัยระดับกองทัพ",
  "PrivacyPolicy.s3.h1.l1": "Secure Element ที่ได้รับการรับรองระดับ EAL6+",
  "PrivacyPolicy.s3.h1.l2": "การสื่อสารแบบเข้ารหัสในระดับฮาร์ดแวร์ตลอดเส้นทาง",
  "PrivacyPolicy.s3.h2.title": "2. ฟังก์ชันด้านความปลอดภัย",
  "PrivacyPolicy.s3.h2.l1": "ยืนยันตัวตนด้วยลายนิ้วมือ",
  "PrivacyPolicy.s3.h2.l2": "โหมดความเป็นส่วนตัว",
  "PrivacyPolicy.s3.h2.l3": "การจัดการหลายกระเป๋าเงินแบบแยกส่วน",
  "PrivacyPolicy.s3.h3.title": "3. การแยกตัวสมบูรณ์",
  "PrivacyPolicy.s3.h3.l1": "ไม่มีการเชื่อมต่ออินเทอร์เน็ต",
  "PrivacyPolicy.s3.h3.l2": "ไม่มีการเชื่อมต่อผ่านสายข้อมูล",
  "PrivacyPolicy.s3.h4.title": "4. ป้องกันการงัดแงะพร้อมการทำลายตัวเอง",
  "PrivacyPolicy.s3.h4.desc":
    "หากอุปกรณ์ถูกถอด แยกชิ้นส่วน เสียหาย หรือถูกบุกรุกอย่างผิดปกติ Secure Element จะทำลายข้อมูลที่อ่อนไหวโดยอัตโนมัติเพื่อป้องกันไม่ให้ดึงกุญแจส่วนตัวออกมาได้",
  "PrivacyPolicy.s3.h5.title":
    "5. ปฏิบัติการที่อ่อนไหวดำเนินการภายใน Secure Element เท่านั้น",
  "PrivacyPolicy.s3.h5.l1": "การสร้างกระเป๋าเงิน",
  "PrivacyPolicy.s3.h5.l2": "การนำเข้ากระเป๋าเงิน",
  "PrivacyPolicy.s3.h5.l3": "การลงนามธุรกรรม",
  "PrivacyPolicy.s3.h5.note":
    "กระบวนการที่อ่อนไหวทั้งหมดเกิดขึ้น 100% ภายใน Secure Element และไม่ถูกเปิดเผยต่อชิปหรือพื้นที่จัดเก็บที่ไม่ปลอดภัยใดๆ",
  "PrivacyPolicy.s3.h6.title":
    "6. ไม่มีการจัดเก็บข้อมูลที่อ่อนไหวไว้นอก Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "พื้นที่จัดเก็บที่ไม่ปลอดภัยบนอุปกรณ์จะไม่จัดเก็บกุญแจส่วนตัว วลีช่วยจำ หรือข้อมูลที่อ่อนไหวใดๆ",

  "PrivacyPolicy.s4.title":
    "4. การออกแบบด้านความเป็นส่วนตัวและความปลอดภัยของแอป LUKKEY",
  "PrivacyPolicy.s4.desc":
    "แอป LUKKEY มุ่งเน้นเฉพาะการแสดงผลข้อมูลและการแจ้งเตือนเท่านั้น และไม่จัดการข้อมูลกระเป๋าเงินที่อ่อนไหว",
  "PrivacyPolicy.s4.n1.title": "1. สิ่งที่แอปไม่ทำ",
  "PrivacyPolicy.s4.n1.l1": "ไม่สร้างกระเป๋าเงินบล็อกเชน",
  "PrivacyPolicy.s4.n1.l2": "ไม่นำเข้ากระเป๋าเงินบล็อกเชน",
  "PrivacyPolicy.s4.n1.l3": "ไม่จัดเก็บกุญแจส่วนตัวหรือวลีช่วยจำ",
  "PrivacyPolicy.s4.n1.l4": "ไม่อัปโหลดข้อมูลผู้ใช้ใดๆ",
  "PrivacyPolicy.s4.n1.l5":
    "ไม่ดำเนินการวิเคราะห์พฤติกรรม การติดตามโฆษณา หรือการเก็บรวบรวมข้อมูล",
  "PrivacyPolicy.s4.n2.title": "2. สิ่งที่แอปทำ",
  "PrivacyPolicy.s4.n2.l1":
    "แสดงข้อมูลที่เข้าถึงได้สาธารณะซึ่งได้รับอนุญาตโดยฮาร์ดแวร์",
  "PrivacyPolicy.s4.n2.l2":
    "มีแผงการตั้งค่าความเป็นส่วนตัวอธิบายวัตถุประสงค์ของแต่ละการอนุญาต",
  "PrivacyPolicy.s4.n2.l3":
    "ให้ผู้ใช้ควบคุมการเปิด/ปิดการอนุญาตได้อย่างเต็มที่ทุกเมื่อ",
  "PrivacyPolicy.s4.n2.l4": "มีการปกปิด (masking) สำหรับข้อมูลที่อ่อนไหว",
  "PrivacyPolicy.s4.n2.l5": "ปิดการจับภาพหน้าจอ/บันทึกหน้าจอในบางหน้าจอ",
  "PrivacyPolicy.s4.n2.l6":
    "ตรวจจับที่อยู่บล็อกเชนที่น่าสงสัยผ่านการจับคู่แบบภายในเครื่อง",
  "PrivacyPolicy.s4.n2.l7":
    "อัปเดตรายการ URL สัญญา และที่อยู่ที่อันตรายอย่างสม่ำเสมอ",
  "PrivacyPolicy.s4.n2.l8":
    "ทิศทางการอัปเดตทางเดียว: จากเซิร์ฟเวอร์ → ไปยังอุปกรณ์เท่านั้น",
  "PrivacyPolicy.s4.n2.l9": "ไม่มีการส่งข้อมูลผู้ใช้กลับในระหว่างการอัปเดต",
  "PrivacyPolicy.s4.n3.title": "3. การจัดเก็บภายในเครื่อง",
  "PrivacyPolicy.s4.n3.p1":
    "แอปจัดเก็บเฉพาะข้อมูลที่ไม่ใช่ข้อมูลส่วนตัวภายในเครื่อง เช่น ค่าการตั้งค่า UI ภาษา และธีม ข้อมูลเหล่านี้:",
  "PrivacyPolicy.s4.n3.l1": "จะไม่ถูกอัปโหลด",
  "PrivacyPolicy.s4.n3.l2": "จะไม่ถูกซิงก์",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY ไม่สามารถเข้าถึงได้",

  "PrivacyPolicy.s5.title": "5. การส่งผ่านข้อมูลและนโยบายเซิร์ฟเวอร์",
  "PrivacyPolicy.s5.l1": "เซิร์ฟเวอร์ของ LUKKEY จะไม่จัดเก็บข้อมูลผู้ใช้ใดๆ",
  "PrivacyPolicy.s5.l2":
    "การสื่อสารระหว่างแอป–เซิร์ฟเวอร์จำกัดเฉพาะการอัปเดตฐานข้อมูลและเวอร์ชัน",
  "PrivacyPolicy.s5.l3": "ไม่มีข้อมูลผู้ใช้ใดๆ ถูกส่งในระหว่างการสื่อสาร",
  "PrivacyPolicy.s5.l4":
    "แม้ในกรณีที่เซิร์ฟเวอร์ถูกเจาะ ข้อมูลผู้ใช้ก็จะไม่รั่วไหล เพราะเราไม่เคยได้รับข้อมูลดังกล่าวตั้งแต่แรก",

  "PrivacyPolicy.s6.title": "6. ความโปร่งใสแบบโอเพนซอร์ส",
  "PrivacyPolicy.s6.l1": "ซอร์สโค้ดของแอป LUKKEY เป็นโอเพนซอร์ส",
  "PrivacyPolicy.s6.l2": "เฟิร์มแวร์ฝังตัวของฮาร์ดแวร์ LUKKEY เป็นโอเพนซอร์ส",
  "PrivacyPolicy.s6.l3": "เปิดเผยครบถ้วนบน GitHub เพื่อให้ทุกคนตรวจสอบได้",
  "PrivacyPolicy.s6.p": "ความโปร่งใสคือส่วนหนึ่งของความปลอดภัย",

  "PrivacyPolicy.s7.title": "7. การควบคุมของผู้ใช้อย่างสมบูรณ์",
  "PrivacyPolicy.s7.p":
    "แม้ว่าเราจะไม่เก็บรวบรวมข้อมูลผู้ใช้ แต่ผู้ใช้ยังคงควบคุมอุปกรณ์ของตนได้อย่างเต็มที่:",
  "PrivacyPolicy.s7.l1": "คุณสามารถปิดการอนุญาตของแอปได้ทุกเมื่อ",
  "PrivacyPolicy.s7.l2":
    "คุณสามารถลบแอปเพื่อเอาข้อมูลแอปภายในเครื่องทั้งหมดออกได้",
  "PrivacyPolicy.s7.l3":
    "คุณสามารถรีเซ็ตอุปกรณ์ฮาร์ดแวร์เพื่อลบกุญแจส่วนตัวและข้อมูลกระเป๋าเงินอย่างถาวร",
  "PrivacyPolicy.s7.p2":
    "LUKKEY ไม่แทรกแซงและไม่สามารถแทรกแซงการกระทำเหล่านี้ได้",

  "PrivacyPolicy.s8.title": "8. ติดต่อเรา",
  "PrivacyPolicy.s8.p":
    "หากคุณมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้ โปรดติดต่อเรา:",
  "PrivacyPolicy.s8.email": "อีเมล: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "ที่อยู่: สำนักงานใหญ่ LUKKEY, Baarerstrasse 25, 6300 Zug, สวิตเซอร์แลนด์",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "กำลังตรวจสอบ...",
  "EmailOtp.title": "การเข้าถึงจำกัด: กรอกชื่อและอีเมลเพื่อรับรหัสเข้าสู่ระบบ",
  "EmailOtp.nameLabel": "ชื่อ",
  "EmailOtp.namePlaceholder": "กรอกชื่อของคุณ",
  "EmailOtp.emailLabel": "อีเมล",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "ส่งรหัส",
  "EmailOtp.resendCode": "ส่งรหัสอีกครั้ง",
  "EmailOtp.resendWithCountdown": "ส่งอีกครั้งใน {{s}} วินาที",
  "EmailOtp.codeValidityHint": "รหัสยืนยันใช้ได้ 5 นาที โปรดอย่าแชร์ให้ผู้อื่น",
  "EmailOtp.codeLabel": "รหัสยืนยันทางอีเมล",
  "EmailOtp.codePlaceholder": "กรอกรหัสที่ได้รับ",
  "EmailOtp.signIn": "ลงชื่อเข้าใช้",
  "EmailOtp.message.codeSent": "ส่งรหัสยืนยันไปยังอีเมลของคุณแล้ว",
  "EmailOtp.error.nameRequired": "กรุณากรอกชื่อ",
  "EmailOtp.error.invalidEmail": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
  "EmailOtp.error.sendFailed": "ส่งรหัสยืนยันไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
  "EmailOtp.error.codeRequired": "กรุณากรอกรหัสยืนยัน",
  "EmailOtp.error.verificationFailed": "การยืนยันไม่สำเร็จ",
  // ===== Academy i18n =====
  "Academy.hero.alert": "คำเตือนด้านความปลอดภัย: ตรวจสอบลิงก์เสมอ และอย่าเปิดเผยวลีสำหรับกู้คืนเด็ดขาด",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "อะคาเดมี",
  "Academy.hero.subtitle": "คู่มือเชิงปฏิบัติด้านความปลอดภัยคริปโต การดูแลสินทรัพย์ด้วยตนเอง และการใช้งานกระเป๋าเงินเย็น LUKKEY.",
  "Academy.search.placeholder": "ค้นหาบทเรียน แนวปฏิบัติที่ดี และคำถามที่พบบ่อย…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "บทความ",
  "Academy.list.title": "คู่มือล่าสุด",
  "Academy.list.viewAll": "ดูทั้งหมด",
  "Academy.list.empty": "ไม่พบผลลัพธ์ ลองคำค้นอื่น",
  "Academy.image.placeholder": "รูป",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "กลับไปที่อะคาเดมี",
  "AcademyArticle.notFound": "ไม่พบบทความ",
  "AcademyArticle.author": "ผู้เขียน",
  "AcademyArticle.unscheduled": "ยังไม่มีเวลาการเผยแพร่ที่กำหนด",
  "home.hero.reserveCtaLabel": "สิทธิ์เข้าถึงล่วงหน้า — 1 ดอลลาร์",
  "home.hero.reserveCtaNote": "ขอคืนเงินได้เต็มจำนวน ไม่มีข้อผูกมัดในการซื้อ"
};
export default translation;
